import { render, staticRenderFns } from "./DriverAppProfile.vue?vue&type=template&id=4f68ca5c&scoped=true"
import script from "./DriverAppProfile.vue?vue&type=script&lang=js"
export * from "./DriverAppProfile.vue?vue&type=script&lang=js"
import style0 from "./DriverAppProfile.vue?vue&type=style&index=0&id=4f68ca5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f68ca5c",
  null
  
)

export default component.exports